<template>
  <div class="wrapper">
    <div class="board">
      <board-controller/>
    </div>
    <div class="players">
      <div class="player" v-for="i in [0,1,2,3]" :key="i">
        <player-controller/>
      </div>
    </div>
  </div>
</template>

<script>
  import BoardController from '@/views/BoardController'
  import PlayerController from '@/views/PlayerController'

  export default {
    name: 'Testing',
    components: {
      PlayerController,
      BoardController
    },
  }
</script>

<style scoped lang="sass">
  .wrapper
    display: flex
    flex-direction: column

  .board
    flex: 0 0 45vh

  .players
    display: flex
    justify-content: space-between
    flex: 0 0 45vh

  .player
    border: solid 1px $red
    flex: 1 0 25%
    max-width: 24vw
</style>
